import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import type { PocInputValidity } from 'commons/types';
import { useTranslation } from 'core/i18n/i18n';
import { CustomValidationCode } from 'core/utils/backend-service';
import React from 'react';
import { AutomationRulesInput } from '../components/automation-rules-input';
import { AutomationRulesCardLayout, AutomationRulesPocCard } from '../styled/automation-rules.style';
import { OnChangeAutomationRuleStateData } from '../types/automation-rules.type';

interface TitleCardProps {
    name?: string;
    defaultValue?: string;
    type?: string;
    onChange?: (data: OnChangeAutomationRuleStateData) => void;
}

export interface TriggerValidationProps {
    validity: PocInputValidity;
    customValidationCode: CustomValidationCode;
}

export type TitleCardRefProps = {
    setTriggerValidation: (validation: TriggerValidationProps) => void;
};

export const TitleCard = React.forwardRef<TitleCardRefProps, TitleCardProps>((props, ref) => {
    const { name = '', defaultValue = '', type = '', onChange = () => {} } = props || {};
    const { t } = useTranslation();

    const [customValidity, setCustomValidity] = React.useState<TriggerValidationProps | undefined>(undefined);

    React.useImperativeHandle(ref, () => ({
        setTriggerValidation: (validation: TriggerValidationProps) => {
            setCustomValidity(validation);
        },
    }));

    const placeholder = t('settings.system.automation-rules.create-edit.sections.name');

    return (
        <AutomationRulesPocCard rounded>
            <AutomationRulesCardLayout className="alg-itm-ctr">
                <PocTypography variant="subtitle1">
                    {t('settings.system.automation-rules.create-edit.sections.name')}
                </PocTypography>
                <div style={{ width: 530 }}>
                    <AutomationRulesInput
                        name={name}
                        defaultValue={defaultValue}
                        type={type}
                        placeholder={placeholder}
                        customValidity={customValidity?.validity}
                        customValidationCode={customValidity?.customValidationCode}
                        onChange={onChange}
                    />
                </div>
            </AutomationRulesCardLayout>
        </AutomationRulesPocCard>
    );
});

TitleCard.displayName = 'TitleCard';
